// extracted by mini-css-extract-plugin
export default {"close":"_3fRMY"};